<div class="visual-object-icon circle {{imageSet}}" [style.width.px]="size" [style.height.px]="size">
  <co-image [width]="iconSize + 'px'" [height]="iconSize + 'px'" [key]="icon" type="png" isVault="true" [imageSet]="imageSet" class="image"></co-image>
</div>